export default {
  "support.header": "サポート",
  "support.about": "LINK-Jを知る",
  "support.faq": "FAQ",
  "support.contact": "お問い合わせ",
  "support.search.placeholder": "例　ライフサイエンス",
};
